import React, { Component } from 'react';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import { createUser,getsignup } from "../store/actions/masterActions";
import swal from 'sweetalert';
import Select from 'react-select';

class CreateUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstname: '',
            lastname: '',
            fullname: '',
            emailid: '',
            password: '',
            grouparray:[],
            groups:[],
            selectedGroupsId:'',
        }
    }
    componentDidMount() {
        this.dataSync()
    }
    dataSync = async () => {
        let grouparray= [] 
        await this.props.getsignup()
        grouparray=this.props.masterReducer.getsignup[0]
        await this.setState({grouparray})
        console.log('abc' ,this.state.grouparray)
    }
    handleFirstName = (e) => {
        let input = e.target.value
        this.setState({ firstname: input })
    }
    handleLastName = (e) => {
        let input = e.target.value
        this.setState({ lastname: input })
    }
    handleFullName = (e) => {
        let input = e.target.value
        this.setState({ fullname: input })
    }
    handleEmailId = (e) => {
        let input = e.target.value
        this.setState({ emailid: input })
    }
    handlePassword = (e) => {
        let input = e.target.value
        this.setState({ password: input })
    }
    handleRole = (e) => {
       console.log('gr',e)
       let input = e
       this.setState({groups:input,selectedGroupsId:input.value})
    }
    handleSubmit = async () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        let input = {
            FirstName: this.state.firstname,
            LastName: this.state.lastname,
            FullName: this.state.fullname,
            EmailId: this.state.emailid,
            Password: this.state.password,
            GroupId: this.state.selectedGroupsId
        }
        if (input.FirstName=='')
        {
            swal("Please Enter First Name", { icon: "error" })
            return false;

        }
        if (input.LastName=='')
        {
            swal("Please Enter Last Name", { icon: "error" })
            return false;

        }
        if (input.FullName=='')
        {
            swal("Please Enter Full Name", { icon: "error" })
            return false;

        }
        if (input.EmailId=='')
        {
            swal("Please Enter Email Id", { icon: "error" })
            return false;

        }
        if (!regex.test(input.EmailId))
        {
            swal("Email Id is not Valid",
                 "Email Id must contain a special character,number,alphabet",
                    {icon: "error"})
            return false;
        }
        if (input.Password=='')
        {
            swal("Please Enter Password", { icon: "error" })
            return false;

        }
        if (input.GroupId=='')
        {
            swal("Please Select Role", { icon: "error" })
            return false;

        }
       
        await this.props.createUser(input)
        await this.handleReset()
    }
    handleReset = async () => {
        await this.setState ({
            firstname: '',
            lastname: '',
            fullname: '',
            emailid: '',
            password: '',
            groups: '',

        })
    }
    render() {
        return (
              <div className="container form-shadow p-5">
                    <h2 className="text-center mb-4 pb-2">CREATE USER</h2>
                    <div className="row pt-4">
                        <div className='col-md-3'><b>First Name</b></div>
                        <div className='col-md-8'>
                            <input type="text" className='form-control form-control-lg'
                                placeholder="Enter First Name" name="First Name"
                                onChange={(e) => this.handleFirstName(e)} value={this.state.firstname} />
                        </div>
                    </div>
                    <div className="row pt-4">
                        <div className='col-md-3'><b>Last Name</b></div>
                        <div className='col-md-8'>
                            <input type="text" className='form-control form-control-lg'
                                placeholder="Enter Last Name" name="Last Name"
                                onChange={(e) => this.handleLastName(e)} value={this.state.lastname} />
                        </div>
                    </div>
                    <div className="row pt-4">
                        <div className='col-md-3'><b>Full Name</b></div>
                        <div className='col-md-8'>
                            <input type="text" className='form-control form-control-lg'
                                placeholder="Enter Full Name" name="Full Name"
                                onChange={(e) => this.handleFullName(e)} value={this.state.fullname} />
                        </div>
                    </div>
                    <div className="row pt-4">
                        <div className='col-md-3'><b>Email Id</b></div>
                        <div className='col-md-8'>
                            <input type="email" className='form-control form-control-lg'
                                placeholder="xyz@example.com" name="EmailId"
                                onChange={(e) => this.handleEmailId(e)} value={this.state.emailid} />
                        </div>
                    </div>
                    <div className="row pt-4">
                        <div className='col-md-3'><b>Password</b></div>
                        <div className='col-md-8'>
                            <input type="password" className='form-control form-control-lg'
                                placeholder="Enter Password" name="Password"
                                onChange={(e) => this.handlePassword(e)} value={this.state.password} />
                        </div>
                    </div>
                    <div className="row pt-4">
                        <div className='col-md-3'><b>Role</b></div>
                        <div className='col-md-8'>
                            <Select maxMenuHeight={500} placeholder="Select Role" options={this.state.grouparray} onChange={(e)=>this.handleRole(e)} value={this.state.groups}/>      
                        </div>
                    </div>
                    <div className=' mt-3'>
                        <button className="btn2 btn-sms1 rounded-pill ml-4 float-right" type="submit" onClick={() => this.handleSubmit()}>CREATE</button>
                    </div>
                </div>
            
        )

    }
}
const mapStateToProps = (state) => ({masterReducer:state.masterReducer})
export default connect(mapStateToProps, { createUser,getsignup })(CreateUser)
